import request from '@/utils/request'
class parent {
    // /template/queryTemplateInfo/{templateName}
    getmb(templateName) {
        return request({
            url: `/template/queryTemplateInfo/${templateName}`,
            method: 'get'
        })
    }
    ///template/deleteTemplateById/{id}
    delmb(id) {
        return request({
            url: `/template/deleteTemplateById/${id}`,
            method: 'get'
        })
    }
    // /template/updateTemplate
    updatemb(data) {
        return request({
            url: '/template/updateTemplate',
            method: 'post',
            data
        })
    }

    //推送
    tSpuda(url, data) {
        return request({
            url: `/${url}`,
            method: 'post',
            data: data
        })
    }

}
let item = new parent()
export default item